var React = require('react');

function IconSocialTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.405 8.228a15.548 15.548 0 01-4.459 1.222 7.784 7.784 0 003.414-4.297 15.5 15.5 0 01-4.93 1.884A7.767 7.767 0 0020.2 14.12 22.049 22.049 0 014.196 6.007a7.76 7.76 0 00-1.05 3.903A7.767 7.767 0 006.6 16.373a7.745 7.745 0 01-3.517-.971v.1a7.767 7.767 0 006.228 7.613 7.82 7.82 0 01-3.506.133 7.768 7.768 0 007.253 5.39 15.58 15.58 0 01-9.643 3.325c-.62 0-1.239-.036-1.854-.108a21.959 21.959 0 0011.9 3.488c14.284 0 22.092-11.83 22.092-22.09 0-.333-.008-.67-.023-1.003A15.784 15.784 0 0039.4 8.233l.004-.005z","fill":"#1DA1F2"}));
}

IconSocialTwitter.defaultProps = {"fill":"currentColor","aria-hidden":"true","viewBox":"0 0 40 40"};

module.exports = IconSocialTwitter;

IconSocialTwitter.default = IconSocialTwitter;
